"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ComponentContainer = _interopRequireDefault(require("../../../../../Framework/ComponentContainer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var mapStateToProps = function mapStateToProps(_ref) {
  var configurator = _ref.configurator;
  return {
    savedconfiguration: configurator.configuration
  };
};
var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};
var _default = exports["default"] = (0, _ComponentContainer["default"])(mapStateToProps, mapDispatchToProps);